module.exports = __webpack_public_path__ + "media/images/cupos-dc633b0cff1d814dc0eb394279befea1.png";